const en_facility_master = {
    "": "Facility List",
    add: "Add Facility",
    edit: "Edit Facility",
    upload: "Upload Facility Schedule",

    label: {
        name: "Facility Name"
    },

    message: {
        note_upload_title: "Note:",
        note_upload_1: "Only Excel files can be uploaded.",
        note_upload_2: "Only schedules for existing facilities can be modified.",
        note_excel: "Download Excel Template",
        note_term_title: "File Requirements:",
        note_term_1: "Use the provided template.",
        note_term_2: "Fill in the file according to the requirements specified in the template.",
    },

    error: {
        create: "Failed to create facility",
        delete: "Failed to delete facility",
        edit: "Failed to edit facility",
        name: "Facility name is required.",
        category: "Facility category is required.",
        invalid_schedule_range: "Invalid time period.",
        schedule_required: "Time period is required.",
    },

    success: {
        create: "Facility created successfully",
        delete: "Facility deleted successfully",
        edit: "Facility updated successfully",
    },
}

export default en_facility_master;